import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

// PortfolioItem component to display individual projects
const PortfolioItem = ({ projectLink, imgSrc, altText, title, categories }) => {
  // Build the classNames based on the categories for filtering
  const categoryClass = categories.join(' ');

  return (
    <div className={`col-lg-4 col-md-4 col-sm-6 col-xs-12 img mbot30 isotopeSelector ${categoryClass}`}>
      <div className="grid">
        <div className="image-zoom-on-hover">
          <div className="gal-item">
            <a className="black-hover" href={projectLink}> {/* Correctly using projectLink */}
              <img className="img-full img-responsive" src={imgSrc} alt={altText} />
              <div className="tour-layer delay-1"></div>
              <div className="vertical-align">
                <div className="border">
                  <h5>{title}</h5>
                </div>
                <div className="view-all hvr-bounce-to-right slide_learn_btn view_project_btn">
                  <span>View Project</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

// FilterMenu component to display the filter options
const FilterMenu = ({ activeFilter, setActiveFilter }) => {
  const filters = [
    { label: 'All Projects', value: '*' },
    { label: 'Aluminium Work', value: 'aluminium' },
    { label: 'Glass Work', value: 'glass' },
    { label: 'Fabrication Work', value: 'fabrication' },
    { label: 'Renovation Work', value: 'renovation' },
  ];

  return (
    <div className="col-sm-12 col-xs-12">
      <div className="filter-container isotopeFilters">
        <ul className="list-inline filter">
          {filters.map((filter) => (
            <li
              key={filter.value}
              className={activeFilter === filter.value ? 'active' : ''}
            >
              <a href="#" onClick={() => setActiveFilter(filter.value)} data-filter={filter.value}>
                {filter.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

// Portfolio component that manages the filter and portfolio gallery
const Portfolio = () => {
  const [activeFilter, setActiveFilter] = useState('*');

  const projects = [
    {
      projectLink: '/Aluminium-Glass-Office-Partition',
      imgSrc: '/images/keyword/1.jpg',
      altText: 'Aluminium Partition',
      title: 'All Types of Aluminium Glass Office Partition',
      categories: ['aluminium'],
    },
    {
      projectLink: '/Toughened-Glass-Work',
      imgSrc: '/images/keyword/2.jpg',
      altText: 'Toughened Glass',
      title: 'All Types of Toughened Glass Work',
      categories: ['glass'],
    },
    {
      projectLink: '/Soundproof-Glass-Window',
      imgSrc: '/images/keyword/6.jpg',
      altText: 'Toughened Glass',
      title: 'Soundproof Glass Window',
      categories: ['glass'],
    },
    {
      projectLink: '/Door-Partition',
      imgSrc: '/images/keyword/3.jpg',
      altText: 'Door Partition',
      title: 'Door Partition  ',
      categories: ['aluminium', 'glass'],
    },
    {
      projectLink: '/ACP-Cladding-Panel-Installation',
      imgSrc: '/images/keyword/4.jpg',
      altText: 'Door Partition',
      title: 'ACP Cladding Panel Installation',
      categories: ['aluminium', 'glass'],
    },
    {
      projectLink: '/Industrial-Fabrication-Work',
      imgSrc: '/images/keyword/15.jpg',
      altText: 'Fabrication Work',
      title: 'All Types of Industrial Fabrication Work',
      categories: ['fabrication'],
    },
    {
      projectLink: '/Home-Renovation-Work',
      imgSrc: '/images/keyword/18.jpg',
      altText: 'Renovation Work',
      title: ' Painting Work',
      categories: ['renovation'],
    },
    {
      projectLink: '/Painting-Work',
      imgSrc: '/images/keyword/19.jpg',
      altText: 'Renovation Work',
      title: 'Painting Work',
      categories: ['renovation'],
    },
    {
      projectLink: '/Aluminium-Mosquito-Net',
      imgSrc: '/images/keyword/7.jpg',
      altText: 'Mosquito Net',
      title: 'Aluminium Mosquito Net ',
      categories: ['aluminium'],
    },
    {
      projectLink: '/Aluminium-Mosquito-Net',
      imgSrc: '/images/keyword/8.jpg',
      altText: 'Mosquito Net',
      title: ' Bird Net Installation',
      categories: ['aluminium'],
    },
    {
      projectLink: '/Invisible-Grill-Installation',
      imgSrc: '/images/keyword/9.jpg',
      altText: 'MS Fabrication Grills',
      title: 'Invisible Grills ',
      categories: ['fabrication'],
    },
    {
      projectLink: '/Invisible-Grill-Installation',
      imgSrc: '/images/keyword/10.jpg',
      altText: 'MS Fabrication Door Installation',
      title: 'MS Fabrication Door Installation',
      categories: ['fabrication'],
    },
    {
      projectLink: '/MS-Fabrication-Industrial-Shade',
      imgSrc: '/images/keyword/14.jpg',
      altText: 'MS Fabrication Grills',
      title: ' MS Fabrication Work',
      categories: ['fabrication'],
    },
    {
      projectLink: '/Furniture-Work',
      imgSrc: '/images/keyword/16.jpg',
      altText: 'Furniture Work',
      title: 'All Types of Furniture Work',
      categories: ['renovation'],
    },
    {
      projectLink: '/Foil-Ceiling-Work',
      imgSrc: '/images/keyword/20.jpg',
      altText: 'Ceiling Work',
      title: 'Foil Ceiling Work',
      categories: ['renovation'],
    },
  ];

  return (
    <div>
      <Helmet>
        <title>Contact: +91 8793220265 | Anjali Enterprises | Aluminium Glass Office Partition Services</title>
        <meta name="description" content="Anjali Enterprises provides all types of Aluminium Glass Office Partition solutions in Pune, including office glass partition installation, room dividers, and premium soundproof partitions. Call +91 8793220265 for more details." />
        <meta name="keywords" content="Aluminium Glass Partition, Office Glass Partition Installation, Glass Partition for Offices in Pune, Office Room Divider Glass, Aluminium Partitioning for Offices, Partitioning Solutions, Best Office Partitions in Pune, Aluminium Framed Glass Office Partition, Modern Office Partitions, Partition Wall Installation, Pune Office Glass Partition Service, Glass Partition Work in Pune, Premium Office Partitions, Soundproof Glass Partitions, Glass Partition Contractors Pune" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | Aluminium Glass Office Partition Services" />
        <meta property="og:description" content="Anjali Enterprises provides all types of Aluminium Glass Office Partition solutions in Pune, including office glass partition installation, room dividers, and premium soundproof partitions. Call +91 8793220265 for more details." />
        <meta property="og:image" content="https://anjalienterprisesindia.com/images/office-partition-service.jpg" />
        <meta property="og:url" content="https://anjalienterprisesindia.com/aluminium-glass-office-partition" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Anjali Enterprises" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "LocalBusiness",
              "name": "Anjali Enterprises",
              "description": "Anjali Enterprises provides all types of Aluminium Glass Office Partition solutions in Pune, including office glass partition installation, room dividers, and premium soundproof partitions. Call +91 8793220265 for more details.",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Pune, Maharashtra",
                "addressLocality": "Pune",
                "addressRegion": "Maharashtra",
                "postalCode": "411057",
                "addressCountry": "IN"
              },
              "telephone": "+91-8793220265",
              "email": "info@anjalienterprisesindia.com",
              "url": "https://anjalienterprisesindia.com/aluminium-glass-office-partition",
              "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
              "image": "https://anjalienterprisesindia.com/images/office-partition-service.jpg",
              "priceRange": "₹1000 - ₹10000",
              "offers": {
                "@type": "Offer",
                "url": "https://anjalienterprisesindia.com/aluminium-glass-office-partition",
                "priceCurrency": "INR",
                "price": "1000",
                "priceValidUntil": "2025-12-31"
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.7",
                "reviewCount": "45"
              },
              "review": [
                {
                  "@type": "Review",
                  "author": {
                    "@type": "Person",
                    "name": "Rajesh T"
                  },
                  "datePublished": "2024-08-10",
                  "reviewBody": "Anjali Enterprises did an excellent job with our office partition. The glass partition installation was smooth, and the final result looks amazing. Highly recommended!"
                },
                {
                  "@type": "Review",
                  "author": {
                    "@type": "Person",
                    "name": "Sanya M"
                  },
                  "datePublished": "2024-09-18",
                  "reviewBody": "I am very pleased with the soundproof glass partitions they installed in our office. The quality and finishing are top-notch."
                }
              ],
              "serviceArea": {
                "@type": "Place",
                "name": "Anjali Enterprises Service Area",
                "geo": {
                  "@type": "GeoCoordinates",
                  "latitude": "18.5195",
                  "longitude": "73.8551"
                }
              },
              "availableChannel": {
                "@type": "ServiceChannel",
                "serviceUrl": "https://anjalienterprisesindia.com/aluminium-glass-office-partition"
              },
              "keywords": "Aluminium Glass Partition, Office Glass Partition Installation, Glass Partition for Offices in Pune, Office Room Divider Glass, Aluminium Partitioning for Offices, Partitioning Solutions, Best Office Partitions in Pune, Aluminium Framed Glass Office Partition, Modern Office Partitions, Partition Wall Installation, Pune Office Glass Partition Service, Glass Partition Work in Pune, Premium Office Partitions, Soundproof Glass Partitions, Glass Partition Contractors Pune"
            }
          `}
        </script>
      </Helmet>

      {/* Banner Section */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1>Portfolio</h1>
        </div>
      </div>

      {/* Portfolio Section */}
      <section className="portfoio-section3">
        <div className="container">
          {/* Filter Section */}
          <div className="filter-section">
            <FilterMenu activeFilter={activeFilter} setActiveFilter={setActiveFilter} />
          </div>

          {/* Portfolio Gallery */}
          <div className="portfolio-section port-col project_classic portfolio-3">
            <div className="isotopeContainer">
              {projects
                .filter((project) => activeFilter === '*' || project.categories.includes(activeFilter))
                .map((project, index) => (
                  <PortfolioItem
                    key={index}
                    projectLink={project.projectLink}
                    imgSrc={project.imgSrc}
                    altText={project.altText}
                    title={project.title}
                    categories={project.categories}
                  />
                ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Portfolio;
